<mat-dialog-content>
  <div class="d-flex">
    <div class="flex-grow-1">
      <h4>{{ 'mapping.specifications.specificationUpload.uploadSpecification' | translate }}</h4>
    </div>
  </div>
  <div class="upload-content">
    <div class="upload-file mt-1 py-2">
      <input
        class="w-100"
        type="file"
        [(ngModel)]="fileInput"
        (change)="onFileUpload($event)"
        accept=".json" />
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="primary-btn me-2 text-center" mat-dialog-close type="button">
    {{ 'global.close' | translate }}
  </button>
  <button
    class="primary-btn me-2 text-center"
    type="button"
    [disabled]="!fileDetails"
    (click)="uploadAddress()">
    {{ 'global.upload' | translate }}
  </button>
</mat-dialog-actions>
